import { render, staticRenderFns } from "./OrderListPanel.vue?vue&type=template&id=72d5ff7c&scoped=true"
import script from "./OrderListPanel.vue?vue&type=script&lang=js"
export * from "./OrderListPanel.vue?vue&type=script&lang=js"
import style0 from "./OrderListPanel.vue?vue&type=style&index=0&id=72d5ff7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5ff7c",
  null
  
)

export default component.exports